var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileNav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.770996 0.75C0.770996 0.335786 1.10678 0 1.521 0H16.021C16.4352 0 16.771 0.335786 16.771 0.75C16.771 1.16421 16.4352 1.5 16.021 1.5H1.521C1.10678 1.5 0.770996 1.16421 0.770996 0.75ZM0.770996 6C0.770996 5.58579 1.10678 5.25 1.521 5.25H16.021C16.4352 5.25 16.771 5.58579 16.771 6C16.771 6.41421 16.4352 6.75 16.021 6.75H1.521C1.10678 6.75 0.770996 6.41421 0.770996 6ZM0.770996 11.25C0.770996 10.8358 1.10678 10.5 1.521 10.5H16.021C16.4352 10.5 16.771 10.8358 16.771 11.25C16.771 11.6642 16.4352 12 16.021 12H1.521C1.10678 12 0.770996 11.6642 0.770996 11.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileNav);
export default __webpack_public_path__ + "static/media/mobile-nav.bad0aacb7ebcd98632da28e9ebeadddf.svg";
export { ForwardRef as ReactComponent };